import { dataAPI } from "../api"
import { IConcept } from "../../components/resources"
import { ConceptResourceDTO } from "../models/resources"
import { ODataGetResourceResponse } from "../models/api/data"

export const getConcept = (id: number): Promise<IConcept> =>
    dataAPI
        .getJSON<ODataGetResourceResponse<ConceptResourceDTO>>(
            `concepts(${id})?$expand=workspace`,
        )
        .then((Concept) => {
            const { Workspace } = Concept
            const newConcept: IConcept = {
                id: Concept.Id,
                title: Concept.Label,
                doesExist: true,
                workspace: {
                    id: Workspace.Id,
                    title: Workspace.Label,
                    doesExist: true,
                },
            }

            return newConcept
        })
